/**
 * tdesign v0.46.3
 * (c) 2022 tdesign
 * @license MIT
 */

import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _Notification from './notification.js';
import { DEFAULT_Z_INDEX, PLACEMENT_OFFSET, DISTANCE } from './const.js';
import { getClassPrefixMixins } from '../config-provider/config-receiver.js';
import mixins from '../utils/mixins.js';
import 'lodash/isFunction';
import 'tdesign-icons-vue';
import '../utils/render-tnode.js';
import '@babel/runtime/helpers/typeof';
import 'vue';
import 'lodash/camelCase';
import 'lodash/kebabCase';
import './props.js';
import 'lodash/mergeWith';
import '../config-provider/context.js';
import 'lodash/merge';
import '../_common/js/global-config/default-config.js';
import '../_common/js/global-config/locale/zh_CN.js';
import '../config-provider/type.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var classPrefixMixins = getClassPrefixMixins("notification");
var NotificationList = mixins(classPrefixMixins).extend({
  components: {
    Notification: _Notification
  },
  props: {
    placement: {
      type: String,
      "default": "top-right",
      validator: function validator(v) {
        return ["top-left", "top-right", "bottom-left", "bottom-right"].indexOf(v) > -1;
      }
    }
  },
  data: function data() {
    return {
      list: []
    };
  },
  computed: {
    styles: function styles() {
      return _objectSpread({
        zIndex: DEFAULT_Z_INDEX
      }, PLACEMENT_OFFSET[this.placement]);
    }
  },
  methods: {
    add: function add(options) {
      this.list.push(options);
      return this.list.length - 1;
    },
    remove: function remove(index) {
      this.list.splice(index, 1);
    },
    removeAll: function removeAll() {
      this.list = [];
    },
    getOffset: function getOffset(val) {
      if (!val) return;
      return isNaN(Number(val)) ? val : "".concat(val, "px");
    },
    notificationStyles: function notificationStyles(item) {
      var styles = {
        marginBottom: DISTANCE
      };

      if (item.offset) {
        styles.position = "relative";
        styles.left = this.getOffset(item.offset[0]);
        styles.top = this.getOffset(item.offset[1]);
      }

      if (item.zIndex) styles["z-index"] = item.zIndex;
      return styles;
    },
    getListeners: function getListeners(index) {
      var _this = this;

      return {
        "close-btn-click": function closeBtnClick() {
          return _this.remove(index);
        },
        "duration-end": function durationEnd() {
          return _this.remove(index);
        }
      };
    }
  },
  render: function render() {
    var _this2 = this;

    var h = arguments[0];
    if (!this.list.length) return;
    return h("div", {
      "class": "".concat(this.componentName, "__show--").concat(this.placement),
      "style": this.styles
    }, [this.list.map(function (item, index) {
      return h("t-notification", {
        "key": item.id,
        "style": _this2.notificationStyles(item),
        "props": _objectSpread({}, item),
        "on": _objectSpread({}, _this2.getListeners(index))
      });
    })]);
  }
});

export { NotificationList as default };
//# sourceMappingURL=notificationList.js.map
